import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureSettingsService } from 'app/services/feature-settings.service';
import { AuthRepository, UserRole } from '../auth.repository';

/**
 * /sales: the global e-commerce switch must be on. SuperUser/SysAdmin may then open it
 * for every company; anyone else needs Website Sales on for their own company.
 * Same rule as the "Sales" menu item.
 */
export const salesGuard: CanActivateFn = () => {
  const features = inject(FeatureSettingsService);
  const role = inject(AuthRepository).getUser()?.role;
  const allowed = role === UserRole.SuperUser || role === UserRole.SysAdmin
    ? features.isWebsiteSalesAllowed()
    : features.isWebsiteSalesEnabled();
  return allowed || inject(Router).createUrlTree(['/home']);
};

/** /purchases: students of a company that sells online. Same rule as "My purchases". */
export const purchasesGuard: CanActivateFn = () => {
  const allowed = inject(AuthRepository).getUser()?.role === UserRole.Student
    && inject(FeatureSettingsService).isWebsiteSalesEnabled();
  return allowed || inject(Router).createUrlTree(['/home']);
};
